// extracted by mini-css-extract-plugin
export default {"page":"lj-z","cartModal":"mj-z","checkout":"nj-z","placeholder":"oj-z","account":"pj-z"};